export default __webpack_public_path__ + "images/PNP.2695cc1.png";